export default {
  placeholder: 'Teil auswählen',
};
